// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_gB","catalogByServiceItem__title":"c-h_gC"};